import React, { useCallback, useContext, useState } from "react";
import {
  ActionList,
  Bleed,
  BlockStack,
  Box,
  Button,
  Card,
  Collapsible,
  Divider,
  Icon,
  InlineStack,
  Text,
} from "@shopify/polaris";

// config
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import quickSettingConfig from "app/reports/operator/widgets/quickSetting/quickSettingConfig";
import { baseHelper } from "lib/helpers";
import { useLocation, useNavigate } from "react-router-dom";
import quickLink from "./quickLinkConfig";

const OperatorQuickLink = (props) => {
  const { link: actionLink = [] } = props;
  const { cms, currentUser } = useContext(PrivateContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname: path } = location;
  const [openActionLink, setActive] = useState(false);
  const [actionLinkExpanded, setExpanded] = useState(true);
  const handleToggle = useCallback(() => setActive((link) => !link), []);
  const quickLinkConfig = quickLink(cms);
  const { config, title } = quickSettingConfig(cms);

  const actionCard = (action) => {
    const onAction = () => (action.onClick ? action.onClick() : navigate(action.link));
    return (
      <>
        {/* <ActionList
          sections={[
            {
              items: [
                {
                  content: action.label,
                  helpText: action.caption,
                  icon: action.icon,
                  onAction,
                },
              ],
            },
          ]}
        /> */}
        <div onClick={onAction} className="button-clone">
          <InlineStack align="start" blockAlign="center" gap="200">
            <Box width="20px">
              <Icon source={action.icon} color="base" />
            </Box>
            <BlockStack>
              <Text id="link-text-custom" fontWeight="bold">
                {action.label}
              </Text>
              <Text tone="subdued" as="p" variant="bodySm">
                {action.caption}
              </Text>
            </BlockStack>
          </InlineStack>
        </div>
      </>
    );
  };

  const viewTerms = (setting) =>
    !(baseHelper.isEcommerceUser(currentUser) && setting.label === baseHelper.ucFirst(constant.TERMS));

  const getQuickLinks = (links = []) => {
    let updatedActions = [...links];
    if (currentUser.ecommercePlatform) {
      updatedActions = updatedActions.filter((item) => item.id !== "exportOrder");
    }
    return updatedActions.map((link) => actionCard(link));
  };

  const getQuickSettings = (settings = []) => {
    return settings.map((setting) => (viewTerms(setting) ? actionCard(setting) : ""));
  };
  const quickActions = (actionLink.length && actionLink) || quickLinkConfig[path];
  // return null;
  return (
    <>
      <Card>
        {/* <Card.Header title={constant.ACTION}>
          <Button
            variant="plain"
            disclosure={actionLinkExpanded ? constant.DOWN : constant.UP}
            onClick={() => {
              handleToggle();
              setExpanded(!actionLinkExpanded);
            }}
          >
            {actionLinkExpanded ? constant.SHOW : baseHelper.ucFirst(constant.HIDE)}
          </Button>
        </Card.Header> */}
        {/* <Box paddingBlockEnd={"400"}> */}
        <InlineStack blockAlign="center" align="space-between">
          <Text variant="headingSm" as="h1">
            {constant.ACTION}
          </Text>
          <Button
            onClick={() => {
              handleToggle();
              setExpanded(!actionLinkExpanded);
            }}
            disclosure={actionLinkExpanded ? constant.DOWN : constant.UP}
            variant="plain"
          >
            {actionLinkExpanded ? constant.SHOW : baseHelper.ucFirst(constant.HIDE)}
          </Button>
        </InlineStack>
        {/* </Box> */}

        <Collapsible
          open={openActionLink}
          id="collapsibleQuickLink"
          transition={{ duration: "150ms", timingFunction: "ease" }}
        >
          <br />
          <BlockStack gap="400">{getQuickLinks(quickActions)}</BlockStack>
          <br />

          {config[path] && (
            <>
              <Divider />
              <br />
              <Text fontWeight="bold">{title[path] || cms("common.actions.title.setting")}</Text>
              <br />
              <BlockStack gap="400">{getQuickSettings(config[path])}</BlockStack>
            </>
          )}
        </Collapsible>
      </Card>
      <br />
    </>
  );
};

export default OperatorQuickLink;
